export const environment = {
  production: true,
  api_site: 'https://test-api.crm.cashpos.cloud/api/v1',
  gmapsKey : 'AIzaSyCcYuL2IRZav3HAqYvwWTrSqofeMmQlnVw'
};
